export const MessageConstants = Object.freeze({

  /**
   * TCU
   */
  DEVICE_ADDED: "Device added successfully",
  DEVICE_UPDATED: "Device updated successfully",

  /**
   * Vehicle
   */
  DEFLEET_VEHICLES_INITIATED: "Defleet vehicle(s) initiated",
  VEHICLE_ENROLLMENT_INITIATED: "Vehicle enrollment initiated, would be notified once complete/failed.",
  VEHICLE_UNENROLLMENT_INITIATED: "Vehicle unenrollment initiated, would be notified once complete/failed.",
  VEHICLE_UNENROLLMENT_FAILED: "Vehicle unenrollment request failed.",
  VEHICLE_ENROLLMENT_FAILED: "Vehicle enrollment request failed.",

  /**
   * TnC
   */
  SELECT_AT_LEAST_1_VEHICLE: "Please select at least 1 vehicle.",
  SELECT_AT_LEAST_1_PACKAGE: "Please select at least 1 package.",

  /**
   * User Password
   */
  UPDATE_PASSWORD_404_ERROR: "User details not found, please request again.",
  UPDATE_PASSWORD_MAX_LIMIT: "Invalid code, # of attempts limit exceeded, please try updating your password after an hour.",
  //maskedEmail is a key and will be replaced in the code.
  CONFRIMATION_CODE_MESSAGE: "Enter confirmation code received at your email address maskedEmail below to update your password"
});